import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap"; 
import Footer from "./Footer";

const About: React.FC = () => {
  return (
    <>
    <div
      style={{
        background: "linear-gradient(135deg, #eff6ff, #ffffff)",
        minHeight: "100vh",
        padding: "70px 0",
      }}
    >
      <Container>
        {/* Hero Section */}
        <Row className="justify-content-center text-center">
          <Col lg="10">
            <h1
              style={{
                fontSize: "3.4rem",
                fontWeight: 800 ,
                color: "#000000",
              }}
            >
              About PriceWorth™
            </h1>

            <p
              style={{
                fontSize: "1.2rem",
                color: "#6b7280",
                marginTop: "25px",
                lineHeight: "1.8",
                textAlign:"left"

              }}
            >
              <strong>PriceWorth™</strong>is a group buying and negotiation platform that helps individuals, 
              students, professionals, and businesses save money by purchasing together.
            </p>

            <p
              style={{
                fontSize: "1.1rem",
                color: "#6b7280",
                lineHeight: "1.8",
                textAlign:"left"
              }}
            >
             Instead of buying individually, we bring together people interested in the same 
             product or service and negotiate with trusted providers to secure better pricing and exclusive offers. 
             The larger the group, the stronger the bargaining power.
            </p>

               <p
              style={{
                fontSize: "1.1rem",
                color: "#6b7280",
                lineHeight: "1.8",
                textAlign:"left"
              }}
            >
              Whether it's professional courses, software subscriptions, business services, 
              insurance, travel packages, automobiles, or other products and services, our goal 
              is simple—help our members get the best possible value.            </p>
          </Col>
        </Row>

        {/* Feature Card */}
        <Row className="justify-content-center mt-5">
          <Col md="10" >
            <Card
              style={{
                border: "none",
                borderRadius: "20px",
                boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
              }}
            >
              <CardHeader
                style={{
                  background: "#000000",
                  color: "#fff",
                  textAlign: "center",
                  fontSize: "28px",
                  fontWeight: "bold",
                  borderTopLeftRadius: "20px",
                  borderTopRightRadius: "20px",
                  padding: "20px",
                }}
              >
                
                How It Works
              </CardHeader>

              <CardBody style={{ padding: "35px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "22px",
                    fontSize: "18px",
                  }}
                >
                  <div >
                  
                   <strong>1. Join a Group</strong> 
                   <p>Select the product or service you're interested in and join or create a buying group.</p>
                  </div>

                  <div >
                    
                   <strong>2. Bigger the group</strong> 
                   <p>As more people join, the group's collective purchasing power increases.</p>
                  </div>

                  <div >
                   
                    <strong>3. We Negotiate</strong> 
                    <p>Our team negotiates with trusted vendors and service providers to obtain the most competitive pricing and exclusive benefits.</p>
                  </div>

                  <div >
                   
                   <strong>4. Save More</strong> 
                   <p>Once an offer is finalized, members can choose to proceed with the purchase and enjoy the negotiated savings.</p>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Bottom Section */}
        <Row className="justify-content-center mt-5">
          <Col lg="10">
            <div
              style={{
                background: "#ffffff",
                borderRadius: "18px",
                padding: "35px",
                textAlign: "center",
                boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              }}
            >
              <h3
                style={{
                  color: "#000000",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Our Mission
              </h3>

              <p
                style={{
                  fontSize: "18px",
                  color: "#555",
                  lineHeight: "1.8",
                }}
              >
                To make quality products and services more affordable by empowering people to buy together and negotiate better.
              </p>

               <h3
                style={{
                  color: "#000000",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Our Vision
              </h3>

              <p
                style={{
                  fontSize: "18px",
                  color: "#555",
                  lineHeight: "1.8",
                }}
              >
                To become most trusted group buying platform, helping millions of consumers and businesses save money through collective purchasing power.
              </p>
            </div>
          </Col>
        </Row>

         <Row className="justify-content-center mt-5">
  <Col lg="10">
    <div
      style={{
        background: "#fff",
        borderRadius: "18px",
        padding: "40px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
      }}
    >
      <h3
        className="text-center mb-4"
        style={{
          color: "#000000",
          fontWeight: "bold",
        }}
      >
        Why Choose <strong>PriceWorth™</strong>
      </h3>

      <Row className="g-4 mb-4">
        <Col md={6} lg={4}>
          <div
            style={{
              padding: "20px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <div style={{ fontSize: "32px" }}>💰</div>
            <h5 className="mt-3">Better Prices</h5>
            <p className="text-muted mb-0">
              Enjoy exclusive discounts through group negotiation.
            </p>
          </div>
        </Col>

        <Col md={6} lg={4}>
          <div
            style={{
              padding: "20px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <div style={{ fontSize: "32px" }}>🤝</div>
            <h5 className="mt-3">Trusted Vendors</h5>
            <p className="text-muted mb-0">
              Work with verified vendors and reliable service providers.
            </p>
          </div>
        </Col>

        <Col md={6} lg={4}>
          <div
            style={{
              padding: "20px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <div style={{ fontSize: "32px" }}>🔍</div>
            <h5 className="mt-3">Transparent Process</h5>
            <p className="text-muted mb-0">
              Every step is clear, fair, and easy to understand.
            </p>
          </div>
        </Col>

        <Col md={6} lg={4}>
          <div
            style={{
              padding: "20px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <div style={{ fontSize: "32px" }}>😊</div>
            <h5 className="mt-3">No Bargaining</h5>
            <p className="text-muted mb-0">
              Skip the hassle of negotiating prices yourself.
            </p>
          </div>
        </Col>

        <Col md={6} lg={4}>
          <div
            style={{
              padding: "20px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <div style={{ fontSize: "32px" }}>🌍</div>
            <h5 className="mt-3">Multiple Industries</h5>
            <p className="text-muted mb-0">
              Access opportunities across a wide range of products and services.
            </p>
          </div>
        </Col>

        <Col md={6} lg={4}>
          <div
            style={{
              padding: "20px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              textAlign: "center",
              height: "100%",
            }}
          >
            <div style={{ fontSize: "32px" }}>👥</div>
            <h5 className="mt-3">Smart Buyer Community</h5>
            <p className="text-muted mb-0">
              Join thousands of customers saving more through collective buying.
            </p>
          </div>
        </Col>
      </Row>

      <p
        className="text-center"
        style={{
          fontSize: "17px",
          color: "#555",
          lineHeight: "1.8",
        }}
      >
        At <strong>PriceWorth™</strong>, we believe every customer deserves the
        benefits of collective buying power. By bringing people together, we
        unlock better pricing, trusted partnerships, and opportunities that are
        typically reserved for large organizations and bulk buyers.
      </p>
    </div>
  </Col>
</Row>

{/* <footer style={{textAlign:"center", marginTop:"20px"}}><strong>PriceWorth™</strong> is owned and operated by <strong>Wocons Private Limited.</strong> </footer> */}
      </Container>
    </div>
    
    <Footer/>
    
    </>
    
  );
};

export default About;